// RevisionStep.tsx

import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  Phrase,
  ButtonsDiv,
  CancelButton,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
} from './style'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/excel/arrow-left.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import axios from 'axios'
import ModalContext from '../../../../contexts/ModalContext'

interface RevisionStepProps {
  isOpen: boolean
  onClose: () => void
}

const RevisionStep = () => {
  const {
    setActiveTab,
    previewSpreadsheet,
    translationMapping,
    updateInOmie,
    setUpdateInOmie,
    calculateLength,
    setCalculateLength,
    calculateWeight,
    setCalculateWeight,
    review,
    setReview,
    setTranslationMapping,
    setLoadingPercentage,
  } = useContext(ImportFromExcelContext)
  const { token } = useContext(UserContext)
  const { tableFile, setTableFile, setImportFromExcelModal } =
    useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)

  useEffect(() => {
    console.log(review)
  }, [])

  const handleSubmit = () => {
    const formData = new FormData()
    formData.append('file', tableFile[0])

    const headers = {
      Authorization: `Bearer ${token}`,
      'Translation-Mapping': JSON.stringify(translationMapping), // Seu objeto de mapeamento aqui
      'Update-in-omie': updateInOmie,
      'Weight-calculate': calculateWeight,
      'Length-calculate': calculateLength,
      'Content-Type': 'multipart/form-data', // Define o tipo de conteúdo para multipart/form-data
    }

    setModalSection('fourthExcelAdd')

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/import-from-excel/upload`,
        formData,
        {
          headers,
        },
      )
      .then((res) => {
        console.log(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const handleCancelImport = () => {
    setModalSection('addStockMenu')
    setTableFile(undefined)
    setTranslationMapping({})
    setUpdateInOmie(false)
    setCalculateLength(false)
    setCalculateWeight(false)
    setReview({ missingColumns: [], wrongColumns: [] })
    setImportFromExcelModal(false)
    setLoadingPercentage(0)
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Importar tabela de estoque: mapeamento</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
      </ProgressBarDiv>
      {review.missingColumns.length === 0 &&
        review.wrongColumns.length === 0 && (
          <Phrase>
            Não foram encontrados erros na planilha ou mapeamento! Clique em
            “Importar” para prosseguir com a importação.
          </Phrase>
        )}

      {review.missingColumns.length !== 0 && (
        <>
          <Phrase>Não foram encontradas as colunas de:</Phrase>
          {review.missingColumns.map((column) => (
            <li key={column}>{column}</li>
          ))}
        </>
      )}

      {review.wrongColumns.length !== 0 && (
        <>
          <Phrase>Existem valores não esperados na coluna:</Phrase>
          {review.wrongColumns.map((column) => (
            <li key={column}>{column}</li>
          ))}
        </>
      )}
      <ButtonsDiv>
        <CancelButton onClick={() => handleCancelImport()}>
          Cancelar
        </CancelButton>
        <PreviousButtonDiv onClick={() => setModalSection('secondExcelAdd')}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        {review.missingColumns.length === 0 &&
        review.wrongColumns.length === 0 ? (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        ) : (
          <DisabledNextButtonDiv>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default RevisionStep
